import { ICON_SIZES } from '@ui-component-library/components/Icon/Icon';
import type { IconSize } from '@ui-component-library/components/Icon/Icon.types';
import COLORS from '@ui-component-library/styles/colors';

import { S } from './Loader.styles';

export type LoaderProps = {
  size?: IconSize;
};

export const Loader = ({ size = 'medium' }: LoaderProps) => {
  const strokeColor = COLORS['charcoal-500'];
  const pixelSize = ICON_SIZES[size];

  return (
    <S.Wrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={pixelSize}
        height={pixelSize}
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M10.333 2.5V5"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.833 10H15.333"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6361 15.3031L13.8682 13.5352"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.333 17.5V15"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.02979 15.3031L6.79775 13.5352"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.83301 10H5.33301"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.02979 4.69678L6.79775 6.46475"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </S.Wrapper>
  );
};
